
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.25 2.25A2.25 2.25 0 0112 4.5a2.221 2.221 0 01-2.25-2.25A2.25 2.25 0 0112 0c1.219 0 2.25 1.031 2.25 2.25zm0 19.5A2.25 2.25 0 0112 24a2.221 2.221 0 01-2.25-2.25A2.25 2.25 0 0112 19.5c1.219 0 2.25 1.031 2.25 2.25zM0 12a2.25 2.25 0 012.25-2.25c1.219 0 2.25 1.031 2.25 2.25a2.25 2.25 0 01-2.25 2.25A2.221 2.221 0 010 12zm24 0a2.25 2.25 0 01-2.25 2.25A2.221 2.221 0 0119.5 12a2.25 2.25 0 012.25-2.25C22.969 9.75 24 10.781 24 12zM3.469 20.484c-.844-.843-.844-2.297 0-3.14.89-.89 2.344-.89 3.187 0a2.18 2.18 0 010 3.14c-.843.891-2.297.891-3.187 0zm3.187-13.78c-.843.89-2.297.89-3.187 0-.844-.845-.844-2.298 0-3.188.89-.844 2.344-.844 3.187 0 .89.89.89 2.343 0 3.187zm10.64 10.64c.845-.89 2.298-.89 3.188 0 .844.843.844 2.297 0 3.14-.89.891-2.343.891-3.187 0a2.18 2.18 0 010-3.14z","fill":"currentColor"}})])
          )
        }
      }
    